import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { animated, useSpring } from '@react-spring/web';
import { useTheme } from '../theme/theme-context';
const StyledButton = styled(animated.button) `
  cursor: pointer;
  border: none;
  background-color: var(--primary);
  text-align: center;
  padding: 4px 16px;
  border-radius: 12px;
  appearance: none;
  color: white;
  height: 24px;
  min-width: 37px;
  position: relative;
  [data-role='switch-indicator'] {
    background-color: white;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    position: absolute;
    bottom: 0px;
    top: 0px;
    margin: auto auto;
    transform: translateX();
  }

  &:focus {
    outline: none;
    border: none;
  }
`;
export const Switch = (props) => {
    const [checked, setChecked] = useState(false);
    const { theme } = useTheme();
    const controlled = useMemo(() => {
        return props.checked || checked;
    }, [props.checked, checked]);
    const styles = useSpring({
        transform: controlled ? 'translateX(0px)' : 'translateX(-15px)',
        backgroundColor: controlled ? theme.color.primary : theme.color.bgColor1,
    });
    const handleSwitch = useCallback(() => {
        var _a;
        (_a = props.onSwitch) === null || _a === void 0 ? void 0 : _a.call(props, !checked);
        setChecked((prev) => !prev);
    }, [props.onSwitch, checked]);
    return (React.createElement(StyledButton, { "data-role": "switch", className: cx('switch', props.className), style: { backgroundColor: styles.backgroundColor }, onClick: handleSwitch },
        React.createElement(animated.div, { style: { transform: styles.transform }, "data-role": "switch-indicator" })));
};
